export type BundleIdentifier = {
  public: string;
  preview: string;
  development: string;
};

export const IOS_BUNDLE_IDENTIFIERS: BundleIdentifier = {
  public: "com.77DowLabs.KaiSocialApp",
  preview: "com.77DowLabs.KaiSocialApp.preview",
  development: "com.77DowLabs.KaiSocialApp.dev",
};

export const ANDROID_BUNDLE_IDENTIFIERS: BundleIdentifier = {
  public: "com.DowLabs.KaiSocial",
  preview: "com.DowLabs.KaiSocial.preview",
  development: "com.DowLabs.KaiSocial.dev",
};
